import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraEntityMatchConfirm } from '@mono/ui-components/lieutenants';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { renderRouterLink } from '../../../lib/renderRouterLink';
/**
 * A pending RFI entity link (WRT-06, v2.3): REG-54's one-click
 * "Is this John Smith (DISA)?" prompt. Options come from the candidate
 * payload; government offices are never created from an RFI.
 */ export function RfiEntityConfirm({ entity, onDecide, busy, readOnly }) {
    const [declined, setDeclined] = useState(false);
    const kind = entity.targetKind;
    return /*#__PURE__*/ _jsx(SpecraEntityMatchConfirm, {
        candidates: entity.options.map((o)=>({
                id: o.registryId,
                name: o.label,
                context: o.sublabel
            })),
        "data-testid": Testids.rfiWorkspace.entityConfirm,
        density: "inline",
        kind: kind,
        observedContext: entity.pendingContext || undefined,
        observedLabel: entity.pendingLabel || 'Unnamed',
        onConfirm: (id)=>onDecide({
                decision: 'link',
                registryId: id
            }),
        onCreateNew: kind === 'GOVERNMENT_ORG' ? undefined : ()=>onDecide({
                decision: 'create'
            }),
        onDecline: ()=>setDeclined(true),
        onDismiss: ()=>onDecide({
                decision: 'dismiss'
            }),
        readOnly: readOnly,
        renderLink: renderRouterLink,
        size: "xs",
        state: busy ? 'pending' : declined ? 'declined' : 'ask'
    });
}
